export enum UserConsentEvent {
    UserConsent = 'SecuritySettings.ClickedUserConsent',
    UserConsentUpgrade = 'SecuritySettings.ClickedUserConsentUpgrade',
    UserConsentContact = 'SecuritySettings.ClickedUserConsentContact',
}
